module.exports = __webpack_public_path__ + "static/media/audio_light.580810af.svg";